import { StateStatusGroups } from 'ContentUtils/constants/StateStatusGroups';
import { PUBLISH_STATUS, TARGETING_STATE } from 'personalization-lib/constants/assetData';
const isUrlFilter = filter => filter.type === 'URL' || filter.type === 'QUERY_PARAM';
const extractBaseFilters = filter => {
  if (filter.type === 'BOOLEAN') {
    return filter.values.flatMap(extractBaseFilters);
  }
  return [filter];
};
const hasVisitorFilters = audienceFilters => {
  if (!audienceFilters) {
    return false;
  }
  return extractBaseFilters(audienceFilters).some(filter => !isUrlFilter(filter));
};
export const getTargetingState = ({
  audienceFilters
}) => {
  if (audienceFilters && hasVisitorFilters(audienceFilters)) {
    return TARGETING_STATE.AUDIENCE_FILTERS;
  }
};
export const getSimplifiedPublishStatus = state => {
  if (StateStatusGroups.SUGGESTED.includes(state)) {
    return PUBLISH_STATUS.AI_SUGGESTED;
  }
  if (StateStatusGroups.SCHEDULED.includes(state)) {
    return PUBLISH_STATUS.SCHEDULED;
  }
  if (StateStatusGroups.PUBLISHED.includes(state)) {
    return PUBLISH_STATUS.PUBLISHED;
  }
  return PUBLISH_STATUS.DRAFT;
};
export const mapContentData = object => ({
  id: object.id,
  status: object.personalizationVariantStatus,
  name: object.label,
  imgSrc: object.screenshotPreviewUrl,
  publishStatus: getSimplifiedPublishStatus(object.currentState),
  targetingState: getTargetingState(object)
});